import { Inject, Injectable } from '@angular/core';
import { CommonModalService } from '../../utils/modals/common-modal.service';
import { CartClearConfirmationService } from '../../services/cart-clear-confirmation.service';
import { ExternalInterfacesService } from '../../external-interfaces/external-interfaces.service';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { FormFieldsMasks } from '../../customer-form/field-mask/form-fields-masks';
import { MsisdnFormat } from '../../utils/pipes/msisdnFormat';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormCustomValidators } from '../../customer-form/form-helpers/form-custom-validators';

export interface ILeadsServiceParams {
  msisdn?: string;
  redirectUrl?: string;
  clearCart?: boolean;
  rejectPromise?: Function;
}

@Injectable()
export class LeadsSupportService {
  private msisdn: string;
  private redirectUrl: string;
  private clearCart = false;
  private themeResourcePath = window['themeResourcePath'] || '';
  private modalData: any;
  public contactMsisdn: string;
  private msisdnFormat: MsisdnFormat = new MsisdnFormat();

  constructor(
    private commonModalService: CommonModalService,
    private cartClearConfirmationService: CartClearConfirmationService,
    private externalInterfacesService: ExternalInterfacesService,
    private commonInfo: CommonInfoService,
    public validationMasks: FormFieldsMasks,
    @Inject('Endpoint') private endpoint: any
  ) {
  }

  public startLeads({msisdn, redirectUrl, clearCart, rejectPromise}: ILeadsServiceParams): void {
    this.msisdn = msisdn;
    this.redirectUrl = redirectUrl;
    this.clearCart = clearCart;

    const modalDataDefault = {
      templateName: CommonModalTemplatesEnum[this.commonInfo.isVirginBrand ? 'CONTACT_REQUEST_VIRGIN_MODAL' : 'CONTACT_REQUEST_MODAL'],
      isLoaderVisible: false,
      themeResourcePath: this.themeResourcePath,
      msisdn: this.msisdn,
      isVirginBrand: this.commonInfo.isVirginBrand
    };

    if (this.redirectUrl) {
      this.modalData = {
        sendContact: (event: Event) => {
          event.preventDefault();

          window.location.href = '/' + this.redirectUrl;
        },
        closeModal: (event: Event) => {
          event.preventDefault();

          window.location.href = '/' + this.redirectUrl;
        }
      };
    } else if (this.clearCart) {
      this.modalData = {
        sendContact: (event: Event) => {
          event.preventDefault();

          this.cartClearConfirmationService.clearData();
        },
        closeModal: (event: Event) => {
          event.preventDefault();

          this.cartClearConfirmationService.clearData();
        }
      };
    } else {
      this.modalData = {
        sendContact: (event: Event) => {
          event.preventDefault();

          this.modalData.isLoaderVisible = true;

          this.sendContact();
        },
      };
    }

    this.modalData = Object.assign(this.modalData, modalDataDefault);
    this.commonModalService.setData(this.modalData, rejectPromise);
  }

  public sendContact(msisdn?: string): void {
    const formatedMsisdn = (value: string) =>
      this.msisdnFormat.transform(value).replace(/\s/g, '');

    if (msisdn) {
      this.msisdn = formatedMsisdn(msisdn);
    }

    const body = {
      mainMsisdnColumnName: formatedMsisdn(this.msisdn),
      source: 'Cart Error',
      url: window.location.href
    };

    try {
      this.endpoint('ccds.contactWithClient', body).run();
      this.showCcdsContactModal();
    } catch {
      this.showCcdsFailureModal();
    }
  }

  private showCcdsContactModal(): void {
    this.externalInterfacesService.updateCartDetails();

    const modalData = {
      templateName: CommonModalTemplatesEnum[this.commonInfo.isVirginBrand ? 'VIRGIN_CCDS_CONTACT_SUCCESS' : 'CCDS_CONTACT_SUCCESS'],
      msisdn: this.msisdn,
      themeResourcePath: this.themeResourcePath,
      isVirginBrand: this.commonInfo.isVirginBrand
    };

    this.commonModalService.setData(modalData);
  }

  private showCcdsFailureModal(): void {
    const modalData = {
      templateName: CommonModalTemplatesEnum.CCDS_CONTACT_FAILURE,
      isLoaderVisible: false,
      themeResourcePath: this.themeResourcePath,
      isVirginBrand: this.commonInfo.isVirginBrand,
      sendContact: (event: Event) => {
        event.preventDefault();

        modalData.isLoaderVisible = true;

        this.sendContact();
      }
    };

    this.commonModalService.setData(modalData);
  }

  public sendContactVirginModal(): void {
    const sendContactNumberForm = new FormGroup({
      number: new FormControl('', [Validators.required, FormCustomValidators.phone])
    });

    const modalData = {
      templateName: CommonModalTemplatesEnum.CONTACT_REQUEST_INPUT_VIRGIN_MODAL,
      isLoaderVisible: false,
      themeResourcePath: this.themeResourcePath,
      contactMsisdn: this.contactMsisdn,
      sendContactNumberForm,
      validationMasks: this.validationMasks,
      sendContact: (event: Event, contactMsisdn: string): void => {
        event.preventDefault();
        modalData.isLoaderVisible = true;
        modalData.sendContactNumberForm.markAllAsTouched();

        if (!modalData.sendContactNumberForm.valid) {
          return;
        }

        this.sendContact(contactMsisdn);
      }
    };

    this.commonModalService.setData(modalData);
  }
}
